import { Alert, Button, Card, Center, Stack, Text } from '@mantine/core';
import { IdentityCard } from './IdentityCard';
import { ANLAM } from '../theme';

/**
 * Veri kapısı kapalı ekranı (F0·S4 kabul çıktısı, F1·S10 kabuğunda):
 * kimlik geçerli (/api/me 200) ama /api/tenant 403 — pasif kayıt, silinmiş
 * kayıt ya da provizyon kuralı olmayan kimlik. Sorun token'da değil, kayıtta.
 */
export function ForbiddenScreen({
  message,
  onLogout,
}: {
  message: string;
  onLogout: () => void;
}): React.JSX.Element {
  return (
    <Center h="100vh" p="md">
      <Card withBorder maw={520} w="100%" padding="xl">
        <Stack>
          <Alert
            color={ANLAM.engel}
            role="alert"
            data-testid="tenant-forbidden"
            title="Veri kapısı kapalı (403)"
          >
            <span data-testid="tenant-forbidden-message">{message}</span>
          </Alert>
          <Text size="sm" c="dimmed">
            Kimlik doğrulandı ama veri kapısı kapalı: kayıt pasif, kayıt silinmiş ya da bu kimlik
            için provizyon kuralı yok. Sistem yöneticinize başvurun.
          </Text>
          <IdentityCard />
          <Button data-testid="sso-logout" variant="default" onClick={onLogout}>
            Çıkış yap
          </Button>
        </Stack>
      </Card>
    </Center>
  );
}
